import { render, staticRenderFns } from "./avaliacaoSideBar.vue?vue&type=template&id=8618084a"
import script from "./avaliacaoSideBar.vue?vue&type=script&lang=js"
export * from "./avaliacaoSideBar.vue?vue&type=script&lang=js"
import style0 from "./avaliacaoSideBar.vue?vue&type=style&index=0&id=8618084a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports